import { Component, OnInit, AfterViewInit, ElementRef, Inject, NgModule, ViewChild, HostListener } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { AnnouncementService } from 'src/app/shared/services/announcementservices/announcement.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { CommonModule, formatDate } from '@angular/common';

import Swal from 'sweetalert2';
import { filter } from 'rxjs/operators';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { AnnouncementGridComponent } from './announcement-management/announcement-grid/announcement-grid.component';
import { AnnouncementViewComponent } from './announcement-management/announcement-view/announcement-view.component';
declare const Swiper: any;

@Component({
  selector: 'app-announcement-main',
  templateUrl: './announcement-main.component.html',
  styleUrl: './announcement-main.component.css',
  animations: [
    trigger('slideToggle', [
      transition(':enter', [
        style({ height: '0px', opacity: 0, overflow: 'hidden' }),
        animate('500ms ease-out', style({ height: '*', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ overflow: 'hidden' }),
        animate('500ms ease-in', style({ height: '0px', opacity: 0 }))
      ])
    ])
  ],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule, AnnouncementGridComponent, AnnouncementViewComponent]
})
export class AnnouncementMainComponent implements AfterViewInit, OnInit {
  public showSpinner = true;
  getAnnouncement: any[] = [];
  announcements: any[] = [];
  today: Date = new Date();
  filterStatus = 'all'; // default show all
  showFilters = false;
  dropdownOpen = false;
  openDropdown: 'month' | 'year' | null = null;
  selectedMonth: string | null = null;
  selectedYear: string | null = null;
  months: string[] = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  idSendToModal: number | null = null;
  selectedCategory = '';
  selectedDate: Date = new Date();
  viewType: 'list' | 'grid' = 'list';
  groupedAnnouncements: any;
  user: any;
  user_role: any;
  adminCheck = false;


  constructor(private router: Router,
    public _announcementService: AnnouncementService,
  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    const roles = JSON.parse(this.user?.user_role?.user_roles)
    this.user_role = roles?.role_type
    if (this.user_role == "Admin" || this.user_role == "Admin_AND_Team_Lead") {
      this.adminCheck = true;
    } else {
      this.adminCheck = false;
    }
  }

  ngOnInit(): void {
    this.selectedDate = new Date();
  }
  ngAfterViewInit(): void {
    this.getAllAnnouncement();
  }
  setView(view: 'list' | 'grid') {
    this.viewType = view;
  }

  goToAddAnnouncement() {
    this.router.navigate(['/add-announcement']);
  }


  getAllAnnouncement(filters: any = {}) {
    this.showSpinner = true;

    this._announcementService.getAnnouncement(filters).then((value) => {
      this.getAnnouncement = value?.data?.all || [];
      this.announcements = value?.data?.all || []
      this.groupedAnnouncements = value?.data;
      // Let Angular render the lists, then init all sliders
      setTimeout(() => this.initAllSwipers(), 0);
      this.showFilters = false;
      this.showSpinner = false;

    });

  }
  onFilterChange(status: string) {
    this.filterStatus = status;
  }


  private initAllSwipers() {
    const containers = document.querySelectorAll('.announcement-swiper');
    containers.forEach((container: any) => {
      // If re-rendering, destroy existing instance first
      if (container.swiper) {
        container.swiper.destroy(true, true);
      }
      new Swiper(container, {
        slidesPerView: 1,
        spaceBetween: 8,
        loop: false, // set true if you want endless loop (adds clones)
        navigation: {
          nextEl: container.querySelector('.swiper-button-next'),
          prevEl: container.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: container.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    });
  }

  isImage(file: string): boolean {
    return /\.(jpg|jpeg|png|gif)$/i.test(file);
  }

  isVideo(file: string): boolean {
    return /\.(mp4|mov|avi)$/i.test(file);
  }

  isExpired(announcement: any): boolean {
    if (!announcement.expiry_date) return false;
    const expiry = new Date(announcement.expiry_date);
    expiry.setHours(23, 59, 59, 999); // expire at end of the day
    return expiry < this.today;
  }

  isActive(announcement: any): boolean {
    if (!announcement.start_date || !announcement.start_time || !announcement.expiry_date) return false;

    const startDateTime = new Date(`${announcement.start_date}T${announcement.start_time}`);
    const expiry = new Date(announcement.expiry_date);
    expiry.setHours(23, 59, 59, 999);

    return this.today >= startDateTime && this.today <= expiry;
  }

  isScheduled(announcement: any): boolean {
    if (!announcement.start_date || !announcement.start_time) return false;

    const startDateTime = new Date(`${announcement.start_date}T${announcement.start_time}`);
    return this.today < startDateTime;
  }
  editAnnouncement(id: number) {
    this.router.navigate(['/add-announcement', id]);
  }

  closeModal() {
    const modal = document.getElementById('deleteAnnouncementModal');
    if (modal) {
      (window as any).$('#deleteAnnouncementModal').modal('hide');
    }
  }



  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  resetFilters(event: Event) {
    event.preventDefault(); // prevent default anchor behavior
    this.selectedCategory = '';
    // this.selectedDate = '';
    this.selectedMonth = null;
    this.selectedYear = null;
    this.openDropdown = null;

    // Optionally, reload announcements without filters
    this.getAllAnnouncement();
  }

  applyFilters() {
    const filters: any = {};

    if (this.selectedCategory) filters.category = this.selectedCategory;
    if (this.selectedDate) filters.date = this.selectedDate;
    if (this.selectedMonth) filters.month = this.selectedMonth;
    if (this.selectedYear) filters.year = this.selectedYear;

    this.getAllAnnouncement(filters);
  }

  toggleDropdown(type: 'month' | 'year') {
    this.openDropdown = this.openDropdown === type ? null : type;
  }

  closeDropdown() {
    this.openDropdown = null;
  }

  selectMonth(month: string, event: Event) {
    event.stopPropagation();
    this.selectedMonth = month;
    this.openDropdown = null;
  }

  // Select year
  selectYear(year: string, event: Event) {
    event.stopPropagation();
    this.selectedYear = year;
    this.openDropdown = null;
  }

  // Close main filter panel if clicked outside
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;

    if (target.closest('.filter-fields') || target.closest('.filter-img-container')) {
      return;
    }

    this.showFilters = false;
    this.openDropdown = null;
  }

  onDateChange(event: Event) {
    const val = (event.target as HTMLInputElement).value;
    if (val) {
      const [year, month, day] = val.split('-').map(Number);
      this.selectedDate = new Date(year, month - 1, day);
    }
  }
  openDatePicker(input: HTMLInputElement) {
    // Modern browsers (Chrome, Edge, Safari 16.4+)
    if (input.showPicker) {
      input.showPicker();
    } else {
      // Fallback for older browsers
      input.click();
    }
  }

}
